module.exports = "https://mrkt.spotifycdn.com/artists-spotify-com/_next/static/images/label-94248aed0b7ee763dcdf3fa390005588.png";